import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './index.css'
import { router } from './router'
import { initSentry, Sentry } from './sentry'
import CrashFallback from './components/CrashFallback'

initSentry()

const ErrorBoundary = Sentry.ErrorBoundary

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={<CrashFallback />}>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>,
)
